<div class="py-4 container-fluid schedule-submissions-page">
  <h4 class="mb-4 schedule-submissions-title">
    {{ pageTitle() }}
  </h4>

  <div class="schedule-submissions-card">
    <div class="schedule-submissions-card-body">
      <div class="schedule-submissions-toolbar" [formGroup]="form">
        <div class="schedule-submissions-filters">
          <div class="schedule-submissions-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="schedule-submissions-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div
            *ngIf="canViewManagerFilters()"
            class="schedule-submissions-search-filter"
          >
            <app-filter-search-input
              label="ตำแหน่งทางวิชาการ, ชื่อ - นามสกุล"
              formControlName="keyword"
              inputClass="schedule-submissions-search-input"
              classes="mb-0"
              ariaLabel="ค้นหาตารางสอน"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          <div
            *ngIf="canViewManagerFilters()"
            class="schedule-submissions-filter"
          >
            <app-select
              label="สาขาวิชา"
              formControlName="departmentId"
              [options]="departmentOptions"
              bindLabel="name"
              bindValue="id"
              [searchable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>

        </div>
      </div>

      <div
        *ngIf="canShowScheduleStatusTabs()"
        class="schedule-submissions-status-tabs-viewport"
      >
        <div class="segmented-tabs segmented-tabs--sm schedule-submissions-status-tabs" role="tablist" aria-label="ตัวกรองสถานะตารางสอน">
          <button
            *ngFor="let tab of statusTabs"
            type="button"
            role="tab"
            class="segmented-tab schedule-submissions-status-tab"
            [class.active]="selectedStatusTab === tab.value"
            [attr.aria-selected]="selectedStatusTab === tab.value"
            (click)="onStatusTabChange(tab.value)"
          >
            {{ tab.label }}
          </button>
        </div>
      </div>

      <div
        *ngIf="canShowBulkEducationHeadConfirm()"
        class="schedule-submissions-bulk-toolbar"
      >
        <span class="schedule-submissions-bulk-count">
          เลือกแล้ว {{ selectedBulkEducationHeadConfirmCount() }} รายการ
        </span>
        <button
          type="button"
          class="btn schedule-submissions-bulk-confirm-button"
          [disabled]="!canBulkEducationHeadConfirm()"
          [attr.aria-disabled]="!canBulkEducationHeadConfirm()"
          (click)="onOpenBulkEducationHeadConfirm()"
        >
          รับรอง
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #bulkSelectHeaderTemplate>
        <input
          type="checkbox"
          class="schedule-submissions-bulk-checkbox"
          aria-label="เลือกตารางสอนทั้งหมดในหน้านี้"
          [checked]="isAllCurrentPageBulkSelected()"
          [indeterminate]="isSomeCurrentPageBulkSelected() && !isAllCurrentPageBulkSelected()"
          (change)="onToggleBulkSelectAllCurrentPage($any($event.target).checked)"
        />
      </ng-template>

      <ng-template #bulkSelectCellTemplate let-row="row">
        <input
          type="checkbox"
          class="schedule-submissions-bulk-checkbox"
          aria-label="เลือกตารางสอน"
          [checked]="isBulkSelected(row)"
          [disabled]="!canSelectForBulkEducationHeadConfirm(row)"
          (change)="onToggleBulkSelection(row, $any($event.target).checked)"
        />
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="schedule-submissions-status-badge"
          [class.schedule-submissions-status-badge-waiting-submit]="isDraftStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-special-revision]="isSpecialRevisionStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-revision]="isRevisionStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-pending]="isPendingStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-completed]="isCompletedStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-waiting-review]="isWaitingEducationHeadReviewStatus(row.statusCode)"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="schedule-submissions-actions">
          <button
            *ngIf="canShowTeacherReviewNotification()"
            type="button"
            class="btn btn-sm btn-primary schedule-submissions-notify-button"
            [disabled]="!row.canNotifyTeacherReview || isNotifyingTeacherReview(row)"
            [title]="teacherReviewNotificationHint(row)"
            (click)="onNotifyTeacherReview(row)"
          >
            {{ isNotifyingTeacherReview(row) ? 'กำลังส่ง...' : 'แจ้งอาจารย์ตรวจสอบ' }}
          </button>
          <button
            type="button"
            class="btn schedule-submissions-action-button datatable-view-action-button"
            aria-label="ดูตารางสอน"
            (click)="onViewSubmission(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="schedule-submissions-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="schedule submissions pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>

  <app-confirm-dialog
    #notifyTeacherConfirmDialog
    modalId="scheduleSubmissionNotifyTeacherConfirm"
    icon="warning"
    title="ต้องการส่งอีเมลแจ้งอาจารย์ตรวจสอบใช่หรือไม่ ?"
    message="ระบบจะส่งอีเมลแจ้งอาจารย์พร้อมรายการวิชาที่รอตรวจสอบ"
    cancelText="ยกเลิก"
    confirmText="ส่งอีเมล"
    [isProcessing]="isPendingTeacherNotificationProcessing()"
    (confirmed)="onConfirmNotifyTeacherReview()"
    (cancelled)="onCancelNotifyTeacherReview()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #notifyTeacherSuccessDialog
    modalId="scheduleSubmissionNotifyTeacherSuccess"
    icon="success"
    title="ส่งอีเมลสำเร็จ"
    [message]="notificationResultMessage()"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="notifyTeacherSuccessDialog.close()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #notifyTeacherErrorDialog
    modalId="scheduleSubmissionNotifyTeacherError"
    icon="error"
    title="ไม่สามารถส่งอีเมลได้"
    [message]="notificationResultMessage()"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="notifyTeacherErrorDialog.close()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #bulkConfirmDialog
    modalId="scheduleSubmissionBulkConfirm"
    icon="warning"
    title="ต้องการยืนยันการรับรองตารางสอนที่เลือกใช่หรือไม่ ?"
    [message]="'ระบบจะรับรองรายวิชาที่รอพิจารณาทั้งหมดจำนวน ' + selectedBulkEducationHeadConfirmIds().length + ' รายการ'"
    cancelText="ยกเลิก"
    confirmText="ยืนยันการรับรอง"
    [isProcessing]="bulkConfirmLoading()"
    (confirmed)="onConfirmBulkEducationHeadConfirm()"
    (cancelled)="onCloseBulkEducationHeadConfirm()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #bulkSuccessDialog
    modalId="scheduleSubmissionBulkSuccess"
    icon="success"
    title="รับรองตารางสอนสำเร็จ"
    [message]="bulkConfirmResultMessage() ?? ''"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="bulkSuccessDialog.close()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #bulkErrorDialog
    modalId="scheduleSubmissionBulkError"
    icon="error"
    title="ไม่สามารถรับรองตารางสอนได้"
    [message]="bulkConfirmResultMessage() ?? ''"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="bulkErrorDialog.close()"
  ></app-confirm-dialog>
</div>
